import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
pdfMake.vfs = pdfFonts.pdfMake.vfs

export default pdfMake

export const pageConfig = {
  pageSize: 'A4',
  pageOrientation: 'portrait',
  pageMargins: [94, 18, 24, 94]
  // pageMargins: [113, 18, 47, 94]
}

export const styles = {
  header: {
    pageBreak: 'before',
    fontSize: '12',
    bold: true,
    alignment: 'center'
  },
  subheader: {
    fontSize: '12',
    bold: true,
    alignment: 'center'
  },
  subimage: {
    fontSize: '10',
    bold: false,
    alignment: 'center'
  },
  title: {
    fontSize: '10',
    bold: true,
    alignment: 'center'
  },
  details: {
    fontSize: '10',
    bold: true,
    alignment: 'left',
    margin: [0, 5, 0, 5]
  },
  signatureBorderTable: {
    margin: [0, 20, 0, 0]
  },
  textCell: {
    fontSize: '8',
    bold: false,
    margin: [0, 2, 0, 2]
  },
  textSignature: {
    fontSize: '10',
    bold: false,
    margin: [0, 2, 0, 2]
  },
  paramsCell: {
    margin: [0, 6, 0, 6]
  },
  paramsCellHeader: {
    fontSize: '7',
    bold: true,
    // alignment: 'center',
    margin: [0, 2, 0, 2]
  },
  image: {
    alignment: 'center',
    // LEFT, TOP, RIGHT, BOTTOM
    margin: [0, 0, 0, 0]
  },
  line: {
    margin: [0, 10, 0, 10]
  }
}
